import _ from 'lodash'
import { gql } from 'graphql-request'
import { createQuery, buildPaginatedResponse } from '@fivehealth/botero'

const GRAPHQL_DOCUMENT = gql`
  query einsteinBroadcasts(
    $status: [EinsteinBroadcastStatusChoices]
    $search: String
    $first: Int
    $offset: Int
    $sortBy: BroadcastOrderBy
    $sortDesc: Boolean
    $createdBy_Uid_In: [String]
  ) {
    einsteinBroadcasts(
      status_In: $status
      offset: $offset
      name_Icontains: $search
      first: $first
      sortBy: $sortBy
      sortDesc: $sortDesc
      createdBy_Uid_In: $createdBy_Uid_In
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          name
          uid
          messages
          messagesWithSecureUrl
          status
          scheduledFor
          recurringFrequencies
          startOn
          endOn
          createdOn
          createdBy {
            uid
            fullName
          }
          rulesets {
            id
            uid
            name
            profiles {
              uid
            }
            allProfiles {
              allUids
            }
            directoryProfiles {
              uid
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'query',
  baseQueryKey: 'einsteinBroadcasts',
  paginate: 'offset',
  select: (data) => buildPaginatedResponse(data, 'einsteinBroadcasts'),
  getNextPageParam: ({ einsteinBroadcasts: data } = {}, allPages) => {
    const hasNextPage = _.get(data, 'pageInfo.hasNextPage', false)
    if (!hasNextPage) {
      return undefined
    }
    const currentOffset = allPages.flatMap(({ einsteinBroadcasts }) =>
      _.get(einsteinBroadcasts, 'edges', [])
    ).length
    return currentOffset
  },
  keepPreviousData: true,
})
